import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PublicHolidayComponent } from './public-holiday/public-holiday.component';
import { PublicHolidaysComponent } from './public-holidays.component';


const routes: Routes = [
 {path :"",component:PublicHolidaysComponent ,children:[
   {path:"PublicHolidays",component:PublicHolidayComponent},
   {path:"", redirectTo: 'PublicHolidays', pathMatch: 'full'},

 
 ]}
 
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
exports: [RouterModule]
})
export class PublicHolidaysRoutingModule { }
